export default __webpack_public_path__ + "static/media/icon-back.b22d855d.svg";